const $ = jQuery;
$(document).ready(function(){

  // Accordion
  $(function () {

    $(".accordion__item:not(:first-of-type) .accordion__content").css("display", "none");

    $(".accordion__item:first-of-type .js-accordion-title").addClass("open");

    $(".js-accordion-title").click(function () {
      $(".open").not(this).removeClass("open").next().slideUp(300);
      $(this).toggleClass("open").next().slideToggle(300);
    });
  });

});
